import React from 'react';
import type { UserType } from 'graphql-ts-types';

import RegistrationDisclaimer from 'common/components/RegistrationDisclaimer';
import RegistrationLegalTerms from 'common/components/RegistrationLegalTerms';

export interface DisclaimerTextProps {
  userType: UserType;
  showHomeClubConsent: boolean;
}

const DisclaimerText = ({ userType, showHomeClubConsent }: DisclaimerTextProps) => (
  <>
    <RegistrationDisclaimer userType={userType} mt={['sp_20', 'sp_16']} mx={['sp_12', 'sp_0']} />
    <RegistrationLegalTerms withHomeClubLegalTerms={showHomeClubConsent} mx={['sp_12', 'sp_0']} />
  </>
);

export default DisclaimerText;
